export default __webpack_public_path__ + "cog-refresh.1adcdf8d17e7161b07ea8c916340fabd.svg";